
import axios from 'axios';
import { getAuthToken } from '../utils/authUtils';

const API_BASE = process.env.REACT_APP_FIREBASE_BACKEND_API_BASE || 'https://quantumleap-emr-dev.web.app';

/**
 * Secure Alert Service
 * Uses backend API endpoints instead of direct Firestore access
 */

// Subscribe to alerts for a patient/encounter/user
export function subscribeToAlerts(filters, onUpdate) {
  // For now, we'll use polling as a fallback
  // In production, this should use WebSocket or Server-Sent Events
  const interval = setInterval(async () => {
    try {
      const alerts = await getAlerts(filters);
      onUpdate(alerts);
    } catch (error) {
      console.error('Error fetching alerts:', error);
      onUpdate([]);
    }
  }, 5000); // Poll every 5 seconds

  // Return cleanup function
  return () => clearInterval(interval);
}

// Get alerts based on filters
export async function getAlerts(filters = {}) {
  try {
    const token = await getAuthToken();
    const response = await axios.get(`${API_BASE}/clinical/alerts`, {
      params: filters,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error('Failed to get alerts');
  } catch (error) {
    console.error('Error getting alerts:', error);
    throw error;
  }
}

// Create a new alert
export async function createAlert(alertData) {
  try {
    const token = await getAuthToken();
    const response = await axios.post(`${API_BASE}/clinical/alerts`, alertData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 201) {
      return response.data;
    }

    throw new Error('Failed to create alert');
  } catch (error) {
    console.error('Error creating alert:', error);
    throw error;
  }
}

// Update an alert
export async function updateAlert(alertId, updateData) {
  try {
    const token = await getAuthToken();
    const response = await axios.put(`${API_BASE}/clinical/alerts/${alertId}`, updateData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error('Failed to update alert');
  } catch (error) {
    console.error('Error updating alert:', error);
    throw error;
  }
}

// Mark alert as read
export async function markAlertAsRead(alertId) {
  try {
    const token = await getAuthToken();
    const response = await axios.put(`${API_BASE}/clinical/alerts/${alertId}/read`, {}, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error('Failed to mark alert as read');
  } catch (error) {
    console.error('Error marking alert as read:', error);
    throw error;
  }
}

// Delete an alert
export async function deleteAlert(alertId) {
  try {
    const token = await getAuthToken();
    const response = await axios.delete(`${API_BASE}/clinical/alerts/${alertId}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error('Failed to delete alert');
  } catch (error) {
    console.error('Error deleting alert:', error);
    throw error;
  }
}
